import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { tap } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/response-model.model';
import { MastersCategoryModel } from './masters.model';

@Injectable({
  providedIn: 'root'
})
export class MastersService {

  constructor(public service: DataService,) { }

  getAllMasters(data:any){
    let url = "api/App/MarketingTemplatesCategories/getAllMarketingTemplateCategories";
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
      return response;
        })
      );
  }

  deleteMasters(id:any){
    let url =`api/App/MarketingTemplatesCategories/deleteMarketingTemplateCategories?Id=${id}`;
    return this.service.delete(url,true).pipe<ResponseModel>(tap((response: any) => {
      return response;
      })
    );
  }

  // create category popup
  insertUpdateMastersCategory(data: MastersCategoryModel){
    let url = "api/App/MarketingTemplatesCategories/insertUpdateMarketingTemplate";
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }
  
}
